import { render, staticRenderFns } from "./BrandsBanner.vue?vue&type=template&id=aa491ff2&"
import script from "./BrandsBanner.vue?vue&type=script&lang=js&"
export * from "./BrandsBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports